import { withLazy } from 'app/hocs/withLazy'

export const ModalAction = withLazy(() => import('common/components/Modal/ModalAction/ModalAction'))
export { default as ModalPreviewFile } from './ModalPreviewFile/ModalPreviewFile'
export const Modal = withLazy(() => import('common/components/Modal/Modal'))
